import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import Button from '../../../common/components/Button';
import * as syncActions from '../../../redux/actionCreators/sync';
import prettyPhone from '../../../lib/prettyPhone';
import {get} from 'lodash';
import {EMPLOYEE_ROLES} from '../../../common/enums';

@connect((state) => ({
  contact: state.contactProfile,
  staticData: state.staticData
}))

export default class ClientWelcome extends React.Component {

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    contact: PropTypes.object.isRequired,
    staticData: PropTypes.object,
  }

  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    this.props.dispatch(syncActions.setNavState({isOpen: true, hideClose: true}));
  }

  render() {

    const companyName = get(this.props.contact, 'company.name');

    const clientAdviserId = get(this.props.contact, 'profile.clientAdvisorId');
    const clientAdviser = this.props.staticData.clientAdvisers.find(adviser => adviser.employeeId === clientAdviserId)
      || this.props.staticData.clientAdvisers.find(adviser => adviser.defaultRole === EMPLOYEE_ROLES.CLIENT_ADVISER);

    const relationshipManagerId = get(this.props.contact, 'company.relationshipManagerId');
    const relationshipManager =
      this.props.staticData.relationshipManagers.find(manager => manager.employeeId === relationshipManagerId);

    return (
      <div className='client-welcome'>
        <div className='top-info-section'>
          <div>
            <span className='top-info-section-company'>Company: {companyName}&nbsp;</span>
            <span className='top-info-section-seperator'>&bull;</span>
            <span className='top-info-section-manager'>Client Adviser: {clientAdviser.firstName} {clientAdviser.lastName}</span>
            {clientAdviser.phoneNumber &&
            <span className='top-info-section-number'>, {prettyPhone(clientAdviser.phoneNumber)}</span>
            }
            {relationshipManager &&
            <span>
              <span className='top-info-section-seperator'>&bull;</span>
              <span className='top-info-section-manager'>Relationship Manager: {relationshipManager.firstName} {relationshipManager.lastName}</span>
              {relationshipManager.phoneNumber &&
              <span className='top-info-section-number'>, {prettyPhone(relationshipManager.phoneNumber)}</span>
              }
            </span>
            }
          </div>
        </div>
        <div className='client-welcome-container'>
          {((user) => {
            if (user) {
              return (
                <div className='client-welcome-content'>
                  <h1 className='header'>Welcome, {this.props.contact.user.firstName}!</h1>
                  <p>
                    You have been added to the system but are still missing some information.
                    please click on the button below to add or edit your infomation
                  </p>
                  <Button
                    data-id='add-button'
                    className='button-main-large'
                    onClick={() => this.props.dispatch(push('/client/edit'))}
                    label='Add Information'/>
                </div>
              );
            }
          })(this.props.contact.user)}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/client/ClientWelcome/index.js